import React from "react";
import { ZOOM_ATTENDANCE_CONSTANTS } from "../../../constants/ZoomAttendance.constants";
import { RangeFilterInput } from "../../common/RangeFilterInput";

export const DurationMinutesRangeFilterInput = (props) => {
  return (
    <RangeFilterInput
      {...props}
      fromKey={ZOOM_ATTENDANCE_CONSTANTS.FIELDS.MINUTES_FROM}
      toKey={ZOOM_ATTENDANCE_CONSTANTS.FIELDS.MINUTES_TO}
      min={0}
      fromPlaceholder={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.ZERO_PLACEHOLDER}
      toPlaceholder={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.MAX_PLACEHOLDER}
    />
  );
};

export const DurationPctRangeFilterInput = (props) => {
  return (
    <RangeFilterInput
      {...props}
      fromKey={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_ATTENDANCE_FROM}
      toKey={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_ATTENDANCE_TO}
      min={0}
      max={100}
      fromPlaceholder={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.ZERO_PLACEHOLDER}
      toPlaceholder={ZOOM_ATTENDANCE_CONSTANTS.FILTERS.HUNDRED_PLACEHOLDER}
    />
  );
};
